var $            = require('./$')
  , assertObject = require('./$.assert').obj;
module.exports = function ownKeys(it){
  assertObject(it);
  return $.getSymbols ? $.getNames(it).concat($.getSymbols(it)) : $.getNames(it);
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel/~/babel-core/~/core-js/modules/$.own-keys.js
 ** module id = 102
 ** module chunks = 0
 **/